"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadioButtonLabel = exports.StyledRadioButtonElement = exports.StyledRadioButtonContainer = exports.StyledRadioButton = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
exports.StyledRadioButton = Theme_1.styled.input `
  // Remove native radio button appearance
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  // Unchecked styles
  border-radius: 50%;
  border: ${(props) => `2px solid ${!(props === null || props === void 0 ? void 0 : props.checked) && !(props === null || props === void 0 ? void 0 : props.disabled)
    ? props.theme.gray2
    : !(props === null || props === void 0 ? void 0 : props.disabled)
        ? props.theme.blue
        : props.theme.gray3}`};
  display: grid;
  height: 16px;
  place-content: center;
  width: 16px;

  &:before {
    border-radius: 50%;
    box-shadow: ${(props) => `inset 0px 0px 0px 10px ${!props.disabled
    ? 'rgb(0, 145, 234)'
    : props.disabled && props.checked
        ? 'rgb(153, 153, 153)'
        : 'rgba(0, 0, 0, 0.0)'}`};
    content: '';
    height: 10px;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    width: 10px;
  }

  &:checked:before {
    transform: scale(1);
  }

  &:disabled:before {
    transform: scale(1);
  }

  &:hover:not([disabled]) {
    box-shadow: 0px 0px 0px 4px rgb(234, 247, 255),
      inset 0px 0px 0px 10px rgb(234, 247, 255);
    border-radius: 50%;
  }
`;
exports.StyledRadioButtonContainer = Theme_1.styled.div `
  display: flex;
  flex-direction: column;
`;
exports.StyledRadioButtonElement = Theme_1.styled.div `
  display: flex;
  flex-direction: row;
  margin-bottom: ${(props) => (props === null || props === void 0 ? void 0 : props.marginBottom) || '8px'};
  width: 100%;
`;
exports.StyledRadioButtonLabel = Theme_1.styled.label `
  color: ${(props) => !(props === null || props === void 0 ? void 0 : props.disabled) ? props.theme.gray2 : props.theme.gray3};
  display: grid;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  gap: ${(props) => (props === null || props === void 0 ? void 0 : props.marginLeft) || '8px'};
  grid-template-columns: 1em auto;
  line-height: 17px;
`;
//# sourceMappingURL=RadioButton.styles.js.map